<template>
    <div class="services-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div class="header-bg" style="background-image: url('https://picsum.photos/id/1073/1920/400');"></div>
            <div class="header-content">
                <h1>业务范围</h1>
                <p>专注于新能源二次设备安装及调试领域，提供专业技术服务</p>
            </div>
        </div>

        <!-- 服务介绍 -->
        <section class="services-intro">
            <div class="container">
                <div class="section-desc">
                    <p>四川庚源电力科技有限公司专注于新能源领域二次设备的安装、调试及技术服务，拥有一支经验丰富的专业团队，为客户提供全方位的技术解决方案。</p>
                </div>

                <div class="services-grid">
                    <div class="service-item">
                        <div class="service-img">
                            <img src="https://0406-lhf.oss-cn-chengdu.aliyuncs.com/ct1.png" alt="二次设备安装">
                        </div>
                        <div class="service-details">
                            <h3>设备安装</h3>
                            <p>专业的新能源电站二次设备安装服务，包括保护装置、测控装置、自动化系统、通信设备等的安装与接线。我们严格按照行业标准和规范进行施工，确保设备安装质量和安全。</p>
                            <ul class="service-features">
                                <li><i class="fa fa-check"></i> 保护屏、控制屏安装与固定</li>
                                <li><i class="fa fa-check"></i> 二次回路接线与检查</li>
                                <li><i class="fa fa-check"></i> 通信线缆敷设与连接</li>
                                <li><i class="fa fa-check"></i> 设备接地与防雷装置安装</li>
                            </ul>
                        </div>
                    </div>

                    <div class="service-item reverse">
                        <div class="service-img">
                            <img src="https://0406-lhf.oss-cn-chengdu.aliyuncs.com/ct2.png" alt="设备调试">
                        </div>
                        <div class="service-details">
                            <h3>现场试验</h3>
                            <p>精准的保护调试服务，确保保护定值正确、逻辑关系无误、通信正常，保障设备安全稳定运行。我们的工程师熟悉各类主流厂家设备，能够快速高效地完成调试工作。</p>
                            <ul class="service-features">
                                <li><i class="fa fa-check"></i> 保护装置定值整定与校验</li>
                                <li><i class="fa fa-check"></i> 测控装置遥信、遥测、遥控调试</li>
                                <li><i class="fa fa-check"></i> 自动化系统逻辑验证</li>
                                <li><i class="fa fa-check"></i> 系统联调与功能测试</li>
                            </ul>
                        </div>
                    </div>

                    <div class="service-item">
                        <div class="service-img">
                            <img src="https://0406-lhf.oss-cn-chengdu.aliyuncs.com/ct3.png" alt="技术支持">
                        </div>
                        <div class="service-details">
                            <h3>技术支持</h3>
                            <p>提供专业的技术咨询与支持，解决设备运行过程中遇到的各种技术问题，保障电站稳定运行。我们拥有完善的技术支持体系，为客户提供及时、有效的技术服务。</p>
                            <ul class="service-features">
                                <li><i class="fa fa-check"></i> 设备故障诊断与排除</li>
                                <li><i class="fa fa-check"></i> 技术方案制定与优化</li>
                                <li><i class="fa fa-check"></i> 现场技术指导与培训</li>
                                <li><i class="fa fa-check"></i> 远程技术支持与咨询</li>
                            </ul>
                        </div>
                    </div>

                    <div class="service-item reverse">
                        <div class="service-img">
                            <img src="https://0406-lhf.oss-cn-chengdu.aliyuncs.com/ct4.png" alt="系统集成">
                        </div>
                        <div class="service-details">
                            <h3>系统集成</h3>
                            <p>新能源电站自动化系统集成服务，实现数据采集、监控、控制等功能的一体化解决方案。我们根据客户需求，提供定制化的系统集成方案，确保系统稳定可靠运行。</p>
                            <ul class="service-features">
                                <li><i class="fa fa-check"></i> 监控系统软硬件集成</li>
                                <li><i class="fa fa-check"></i> 数据通信网络搭建</li>
                                <li><i class="fa fa-check"></i> 系统组态与画面绘制</li>
                                <li><i class="fa fa-check"></i> 系统联调与性能测试</li>
                            </ul>
                        </div>
                    </div>


                </div>
            </div>
        </section>

        <!-- 服务流程 -->
        <section class="service-process">
            <div class="container">
                <h2>服务流程</h2>
                <div class="process-steps">
                    <div class="process-step">
                        <div class="step-number">1</div>
                        <div class="step-content">
                            <h3>需求沟通</h3>
                            <p>了解客户需求，进行现场勘查，制定初步服务方案</p>
                        </div>
                    </div>
                    <div class="process-arrow">
                        <i class="fa fa-long-arrow-right"></i>
                    </div>
                    <div class="process-step">
                        <div class="step-number">2</div>
                        <div class="step-content">
                            <h3>方案制定</h3>
                            <p>根据客户需求和现场情况，制定详细的服务方案和实施计划</p>
                        </div>
                    </div>
                    <div class="process-arrow">
                        <i class="fa fa-long-arrow-right"></i>
                    </div>
                    <div class="process-step">
                        <div class="step-number">3</div>
                        <div class="step-content">
                            <h3>合同签订</h3>
                            <p>与客户确认服务方案，签订服务合同，明确双方权利义务</p>
                        </div>
                    </div>
                    <div class="process-arrow">
                        <i class="fa fa-long-arrow-right"></i>
                    </div>
                    <div class="process-step">
                        <div class="step-number">4</div>
                        <div class="step-content">
                            <h3>现场实施</h3>
                            <p>按照服务方案和实施计划，组织专业团队进行现场服务</p>
                        </div>
                    </div>
                    <div class="process-arrow">
                        <i class="fa fa-long-arrow-right"></i>
                    </div>
                    <div class="process-step">
                        <div class="step-number">5</div>
                        <div class="step-content">
                            <h3>验收交付</h3>
                            <p>服务完成后，组织客户进行验收，提供完整的技术资料</p>
                        </div>
                    </div>
                    <div class="process-arrow">
                        <i class="fa fa-long-arrow-right"></i>
                    </div>
                    <div class="process-step">
                        <div class="step-number">6</div>
                        <div class="step-content">
                            <h3>售后服务</h3>
                            <p>提供售后服务和技术支持，确保客户设备长期稳定运行</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 服务优势 -->
        <section class="service-advantages">
            <div class="container">
                <h2>我们的优势</h2>
                <div class="advantages-grid">
                    <div class="advantage-item">
                        <div class="advantage-icon">
                            <i class="fa fa-users"></i>
                        </div>
                        <h3>专业团队</h3>
                        <p>核心技术人员均具有5年以上新能源行业经验，熟悉各类主流设备，各类资质及特种作业证书齐全</p>
                    </div>
                    <div class="advantage-item">
                        <div class="advantage-icon">
                            <i class="fa fa-handshake-o"></i>
                        </div>
                        <h3>厂家合作</h3>
                        <p>与南瑞继保、北京四方、长园深瑞、国能日新等业内厂家保持密切合作关系，可提供完善的售前、售后服务</p>
                    </div>
                    <div class="advantage-item">
                        <div class="advantage-icon">
                            <i class="fa fa-certificate"></i>
                        </div>
                        <h3>质量保证</h3>
                        <p>严格按照行业标准和规范进行服务，确保服务质量和工程安全，杜绝施工或各类安全隐患</p>
                    </div>
                    <div class="advantage-item">
                        <div class="advantage-icon">
                            <i class="fa fa-bolt"></i>
                        </div>
                        <h3>高效响应</h3>
                        <p>快速响应客户需求，提供及时、专业的技术服务和支持</p>
                    </div>
                    <div class="advantage-item">
                        <div class="advantage-icon">
                            <i class="fa fa-cogs"></i>
                        </div>
                        <h3>丰富经验</h3>
                        <p>参与过多个大型新能源项目，积累了丰富的实践经验，包括建设、改造及综合消缺</p>
                    </div>
                    <div class="advantage-item">
                        <div class="advantage-icon">
                            <i class="fa fa-heart"></i>
                        </div>
                        <h3>客户至上</h3>
                        <p>以客户需求为导向，提供定制化的解决方案和完善服务</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'ServicesPage'
}
</script>

<style scoped>
.page-header {
    position: relative;
    height: 400px;
    overflow: hidden;
}

.header-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    filter: brightness(0.6);
}

.header-content {
    position: relative;
    z-index: 2;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-align: center;
}

.header-content h1 {
    font-size: 3rem;
    margin-bottom: 15px;
}

.header-content p {
    font-size: 1.2rem;
}

section {
    padding: 80px 0;
}

.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

h2 {
    font-size: 2rem;
    color: #2c3e50;
    margin-bottom: 40px;
    text-align: center;
    position: relative;
    display: inline-block;
    left: 50%;
    transform: translateX(-50%);
    padding-bottom: 10px;
}

h2::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background-color: #165DFF;
}

/* 服务介绍样式 */
.services-intro {
    background-color: #f9f9f9;
}

.section-desc {
    text-align: center;
    color: #7f8c8d;
    max-width: 800px;
    margin: 0 auto 60px;
    line-height: 1.8;
    font-size: 1.1rem;
}

.services-grid {
    display: flex;
    flex-direction: column;
    gap: 60px;
}

.service-item {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: center;
}

.service-item.reverse {
    direction: rtl;
}

.service-item.reverse .service-details {
    direction: ltr;
}

.service-img img {
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.service-details h3 {
    font-size: 1.8rem;
    color: #2c3e50;
    margin-bottom: 20px;
}

.service-details p {
    font-size: 1rem;
    line-height: 1.8;
    color: #555;
    margin-bottom: 25px;
}

.service-features {
    list-style: none;
    padding: 0;
}

.service-features li {
    margin-bottom: 10px;
    padding-left: 25px;
    position: relative;
    color: #555;
}

.service-features li i {
    position: absolute;
    left: 0;
    color: #165DFF;
}

/* 服务流程样式 */
.service-process {
    background-color: #fff;
}

.process-steps {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.process-step {
    flex: 1;
    min-width: 150px;
    text-align: center;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    position: relative;
}

.step-number {
    width: 40px;
    height: 40px;
    background-color: #165DFF;
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    margin: 0 auto 15px;
}

.step-content h3 {
    font-size: 1.1rem;
    color: #2c3e50;
    margin-bottom: 10px;
}

.step-content p {
    font-size: 0.9rem;
    color: #7f8c8d;
}

.process-arrow {
    color: #165DFF;
    font-size: 1.5rem;
    display: none;
}

@media (min-width: 992px) {
    .process-arrow {
        display: block;
    }
}

/* 服务优势样式 */
.service-advantages {
    background-color: #f9f9f9;
}

.advantages-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 30px;
}

.advantage-item {
    background-color: #fff;
    padding: 30px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s;
}

.advantage-item:hover {
    transform: translateY(-10px);
}

.advantage-icon {
    width: 70px;
    height: 70px;
    background-color: #f0f5ff;
    color: #165DFF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    font-size: 1.8rem;
}

.advantage-item h3 {
    font-size: 1.3rem;
    color: #2c3e50;
    margin-bottom: 15px;
}

.advantage-item p {
    color: #7f8c8d;
    line-height: 1.6;
}

/* 响应式样式 */
@media (max-width: 992px) {
    .service-item,
    .service-item.reverse {
        grid-template-columns: 1fr;
    }

    .service-item.reverse .service-img {
        order: 1;
    }

    .service-item.reverse .service-details {
        order: 2;
    }
}

@media (max-width: 768px) {
    .header-content h1 {
        font-size: 2.2rem;
    }

    h2 {
        font-size: 1.8rem;
    }

    .service-details h3 {
        font-size: 1.5rem;
    }
}

@media (max-width: 576px) {
    .page-header {
        height: 300px;
    }

    .header-content h1 {
        font-size: 1.8rem;
    }

    .header-content p {
        font-size: 1rem;
    }

    section {
        padding: 50px 0;
    }

    .process-step {
        min-width: 100%;
    }
}
</style>
